import Britz1 from '../../../Media/Citraland Kedamaian/Britz/Britz (1).webp'
import Britz2 from '../../../Media/Citraland Kedamaian/Britz/Britz (1).webp'


const Britzimages =[
Britz1,Britz2
]

export default Britzimages;